module.exports = __webpack_public_path__ + "platform-web/static/media/portal.10567352.svg";